module.exports = __webpack_public_path__ + "static/media/chexiao.d61548dc.svg";